import React, { createContext, useContext, ReactNode, useCallback } from 'react';

type BottomBarContextType = {
    setCustomBottomBar: (element: ReactNode | null) => void;
};

// eslint-disable-next-line react-refresh/only-export-components
export const BottomBarContext = createContext<BottomBarContextType | undefined>(undefined);

export const BottomBarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [customBottomBar, setCustomBottomBarState] = React.useState<ReactNode | null>(null);

    const setCustomBottomBar = useCallback((element: ReactNode | null) => {
        setCustomBottomBarState(element);
    }, []);

    return (
        <BottomBarContext.Provider value={{ setCustomBottomBar }}>
            {children}
            {customBottomBar}
        </BottomBarContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useBottomBar = () => {
    const context = useContext(BottomBarContext);
    if (!context) {
        throw new Error('useBottomBar must be used within a BottomBarProvider');
    }
    return context;
};
